import React from "react";
import { DEFAULT_WIDGET_PRIMARY_COLOR } from "@school-sales-ai/shared";

type Props = {
  // Empty string means "use the default" (persisted as null).
  value: string;
  onChange: (value: string) => void;
  invalid: boolean;
};

const HEX_RE = /^#[0-9a-fA-F]{6}$/;

export function ColorSettings({ value, onChange, invalid }: Props): React.JSX.Element {
  // The native color input needs a concrete hex; fall back to the default swatch
  // when the field is empty or mid-edit so the picker still shows something valid.
  const swatch = HEX_RE.test(value.trim()) ? value.trim() : DEFAULT_WIDGET_PRIMARY_COLOR;
  const isDefault = value.trim() === "";

  return (
    <div className="border-t border-ink-200 pt-4 mt-4">
      <div className="mb-1">
        <p className="text-[13px] font-medium text-ink-900">Color principal del widget</p>
        <p className="text-[12px] text-ink-500 mt-0.5">
          Color de acento del chat embebido (burbuja, botones, mensajes del prospecto).
          Déjalo vacío para usar el color por defecto.
        </p>
      </div>

      <div className="mt-3 flex items-center gap-2">
        <input
          type="color"
          aria-label="Selector de color"
          value={swatch}
          onChange={(e) => onChange(e.target.value)}
          className="h-9 w-10 shrink-0 cursor-pointer rounded-lg border border-ink-200 bg-white p-1"
        />
        <input
          type="text"
          inputMode="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          maxLength={7}
          placeholder={DEFAULT_WIDGET_PRIMARY_COLOR}
          className={`w-32 font-mono text-[13px] border rounded-lg px-3 py-1.5 focus:outline-none text-ink-900 placeholder:text-ink-300 bg-white ${
            invalid ? "border-red-400 focus:border-red-500" : "border-ink-200 focus:border-moss"
          }`}
        />
        {!isDefault && (
          <button
            type="button"
            onClick={() => onChange("")}
            className="text-[12px] font-medium text-ink-500 hover:text-moss"
          >
            Restablecer
          </button>
        )}
      </div>
      {invalid && (
        <p className="text-[11px] text-red-500 mt-1">
          Usa un color hex de 6 dígitos, ej. {DEFAULT_WIDGET_PRIMARY_COLOR}
        </p>
      )}
    </div>
  );
}
